export default {
	//即时聊天
	chatList: '/admin/fb/messenger/chat/list', //fb消息聊天列表API
	headerDetail: '/admin/fb/messenger/chat/detail/{id}/{type}', //fb聊天询盘详情
	chatRecord: '/admin/fb/messenger/chat/listrecord', //聊天记录
	chatToSent: '/admin/web/chatsent/chattosent', //聊天发送
	chatSend: '/admin/web/chatsent/send', //聊天发送二期
	autograph: '/fb/messenger/chat/autograph', //签名
	jpushimuser: '/fb/messenger/chat/jpushimuser',
	chatNum: '/admin/fb/messenger/chat/num', //fb未读数
	chatManual: '/admin/fb/messenger/chat/manual/{id}', //聊天手动转线索
	addchatAccount: '/jpush/web/add',
	bindhomepage: '/admin/fb/messenger/chat/bindhomepage', //判断是否绑定了主页展示营销页
	assignment: '/admin/fb/messenger/chat/assignment', //分配跟进人
	attrDetails: '/admin/fb/messenger/chat/attribution_details/{id}/{type}',
	getContactlist: '/admin/fb/messenger/chat/contactlist/{id}/{type}', //联系人列表
	whatsappChatRecord: '/admin/fb/messenger/chat/whatsapp/listrecord', // whatsapp聊天记录
};
